import React from "react";
import ReactMarkdown from "react-markdown";
import { Container, Card } from "react-bootstrap";

const PoliticaPrivacidade = ({ email, nome_app, data }) => {
    const politicaPrivacidade = `
# **POLÍTICA DE PRIVACIDADE**

**Última Atualização:** ${data}

Esta Política de Privacidade descreve como coletamos, usamos, armazenamos e protegemos as informações dos usuários do aplicativo **${nome_app}**, projetado para gerenciamento de estoque, vendas, recebimentos, agenda, prospecção e visitas a clientes. Ao utilizar nosso aplicativo, você concorda com os termos descritos nesta política.

## 1. INFORMAÇÕES COLETADAS

Nosso aplicativo pode coletar diversos tipos de informações para oferecer uma melhor experiência e garantir a funcionalidade completa da plataforma. Essas informações incluem:

### 1.1 Dados Pessoais

- **Nome completo**
- **Endereço de e-mail**
- **Número de telefone**
- **Credenciais de login** (nome de usuário e senha)
- **Foto de perfil** (caso aplicável)
- **Endereço comercial**, se fornecido pelo usuário

### 1.2 Dados Comerciais

- **Registros de estoque**, incluindo produtos, quantidades e fornecedores
- **Detalhes de vendas**, como produtos vendidos, valores e datas de transações
- **Informações sobre recebimentos e pagamentos**
- **Dados de clientes e prospects**, incluindo histórico de interações e visitas agendadas
- **Anotações e lembretes cadastrados na agenda do aplicativo**

### 1.3 Dados de Uso

- **Informações sobre como o usuário interage com o aplicativo**
- **Registros de acessos e operações realizadas dentro do app**
- **Endereço IP e dispositivo utilizado para acesso**
- **Preferências e configurações personalizadas do usuário**

## 2. USO DAS INFORMAÇÕES

As informações coletadas são utilizadas para diversos propósitos, incluindo:

- **Gerenciar estoque, vendas, recebimentos e agendamentos**
- **Melhorar a experiência do usuário e desenvolver novas funcionalidades**
- **Oferecer suporte ao cliente e resolver problemas técnicos**
- **Enviar comunicações relacionadas ao funcionamento do aplicativo**
- **Garantir a segurança da conta e prevenir fraudes**
- **Cumprir obrigações legais e regulatórias**

## 3. COMPARTILHAMENTO DE DADOS

Nos comprometemos a **não vender, alugar ou compartilhar suas informações pessoais com terceiros**, exceto nos seguintes casos:

- Quando necessário para **cumprir obrigações legais** ou atender a determinação judicial
- Com **prestadores de serviço essenciais** ao funcionamento do aplicativo, como provedores de armazenamento em nuvem e processadores de pagamento
- Com **parceiros de negócios**, desde que o usuário tenha dado consentimento explícito
- No caso de **fusão, aquisição ou venda de ativos**, onde os dados poderão ser transferidos para outra entidade empresarial

## 4. ARMAZENAMENTO E PROTEÇÃO DE DADOS

Adotamos **medidas técnicas e organizacionais** para proteger seus dados contra acessos não autorizados, alterações, divulgação ou destruição indevida. Entre as principais medidas estão:

- **Uso de criptografia** para proteger dados sensíveis
- **Controle de acesso** baseado em autenticação segura
- **Monitoramento contínuo e auditorias de segurança**
- **Backup regular** dos dados armazenados

Os dados são mantidos pelo período necessário para atender às finalidades previstas nesta política ou conforme exigido por lei.

## 5. DIREITOS DO USUÁRIO

Você tem direito a:

- **Acessar, corrigir ou excluir seus dados pessoais**
- **Solicitar a portabilidade dos seus dados para outro serviço**
- **Revogar consentimentos concedidos anteriormente**
- **Solicitar esclarecimentos sobre o uso de suas informações**

Caso deseje exercer seus direitos, entre em contato através do e-mail **${email}**.

## 6. COOKIES E TECNOLOGIAS SEMELHANTES

Nosso aplicativo pode utilizar **cookies e tecnologias semelhantes** para melhorar a experiência do usuário. Esses mecanismos podem ser usados para:

- **Lembrar preferências e configurações**
- **Melhorar a segurança do acesso**
- **Coletar informações sobre a interação do usuário com o app**

Os usuários podem configurar seus dispositivos para **bloquear cookies**, mas isso pode impactar algumas funcionalidades do aplicativo.

## 7. ALTERAÇÕES NA POLÍTICA DE PRIVACIDADE

Reservamo-nos o direito de **modificar esta Política de Privacidade a qualquer momento**. Notificaremos os usuários sobre alterações significativas por meio de **e-mail ou aviso no aplicativo**.

Recomendamos que os usuários revisem periodicamente esta política para se manterem informados sobre como seus dados estão sendo protegidos.

## 8. CONTATO

Se tiver **dúvidas, sugestões ou preocupações** sobre esta Política de Privacidade, entre em contato através do e-mail **${email}**.
`;

    return (
        <Container className="my-4">
            <Card className="shadow-sm">
                <Card.Body>
                    <ReactMarkdown>{politicaPrivacidade}</ReactMarkdown>
                </Card.Body>
            </Card>
        </Container>
    );
};

export default PoliticaPrivacidade;